import React from 'react';
import CustomModal from '../../../../baseComponents/gui/customModal/CustomModal';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import Header from '../header/Header';
import classNames from 'classnames';
import { useModal } from '../../../../../hooks/useModal';

const InfoModal = React.forwardRef(function (
  { title, isTopHeader = false, description, images, buttons, onClose, type },
  ref,
) {
  const { closeModal, id } = useModal();

  const close = () => {
    onClose?.();
    closeModal({ id });
  };

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']} closeOnOverlayClick={true}>
      <div className={classNames('info-modal', { [`info-modal_${type}`]: !!type })} ref={ref}>
        <div className='info-modal__content'>
          {isTopHeader && <Header title={title} description={description} />}

          {!!images?.length && (
            <div className='info-modal__image'>
              {images.map((image, index) => (
                <img key={index} src={image} />
              ))}
            </div>
          )}

          {!isTopHeader && <Header title={title} description={description} />}

          {!!buttons?.length && (
            <div className='info-modal__buttons'>
              {buttons?.map((item, index) => (
                <CustomButton key={index} {...item} className={'info-modal__button'} onClick={close} />
              ))}
            </div>
          )}
        </div>
      </div>
    </CustomModal>
  );
});
export default InfoModal;
InfoModal.propTypes = {};
